module.exports = __webpack_public_path__ + "static/media/Cats Eyes 01_SPANSKA-mixdown.72540762.mp3";